const apiConfig = {
  baseUrl: 'https://api.themoviedb.org/3/',
  apiKey: '930c4384ee32136f0e1325d6e3ce2482',
  originalImage: (imgPath) => `https://image.tmdb.org/t/p/original/${imgPath}`,
  w500Image: (imgPath) => `https://image.tmdb.org/t/p/w500${imgPath}`,
  w200Image: (imgPath) => `https://image.tmdb.org/t/p/w200${imgPath}`,
};

export default apiConfig;
